"use client";

import { useAlertContext } from "@/providers/AlertProvider";

/**
 * Shared delete-confirmation flow, matching the confirm()/success()/error() pattern already
 * used for bulk activate/deactivate on the users page — so every module's delete button looks
 * and behaves the same way.
 */
export function useDeleteConfirm() {
  const { confirm, success, error } = useAlertContext();

  return async function confirmDelete(itemLabel: string, onConfirm: () => Promise<void>) {
    confirm({
      title: "Delete",
      message: `Are you sure you want to delete ${itemLabel}? This cannot be undone.`,
      type: "warning",
      confirmText: "Delete",
      cancelText: "Cancel",
      showCancel: true,
      onConfirm: async () => {
        try {
          await onConfirm();
          success("Deleted", `${itemLabel} was deleted successfully`);
        } catch (err) {
          error("Delete failed", (err as Error)?.message || `Failed to delete ${itemLabel}`);
        }
      },
    });
  };
}
